/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"
import { FontWeight } from "common/styles/font"
import { theme } from "./theme"

export const CONTENT_MAX_WIDTH = 1400
export const CONTENT_MIN_WIDTH = 601

export const TROY_SIDEBAR_WIDTH = 232
export const TROY_SIDEBAR_COLLAPSED_WIDTH = 80

export const globalStyle = css`
  body {
    -webkit-font-smoothing: antialiased;
  }
  @font-face {
    font-family: "Inter Grab Web";
    src: url(${require("grab-ui/assets/fonts/Inter-Light.woff2")})
        format("woff2"),
      url(${require("grab-ui/assets/fonts/Inter-Light.woff")}) format("woff");
    font-weight: ${FontWeight.light};
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Inter Grab Web";
    src: url(${require("grab-ui/assets/fonts/Inter-Regular.woff2")})
        format("woff2"),
      url(${require("grab-ui/assets/fonts/Inter-Regular.woff")}) format("woff");
    font-weight: ${FontWeight.regular};
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Inter Grab Web";
    src: url(${require("grab-ui/assets/fonts/Inter-SemiBold.woff2")})
        format("woff2"),
      url(${require("grab-ui/assets/fonts/Inter-SemiBold.woff")}) format("woff");
    font-weight: ${FontWeight.medium};
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Inter Grab Web";
    src: url(${require("grab-ui/assets/fonts/Inter-Bold.woff2")})
        format("woff2"),
      url(${require("grab-ui/assets/fonts/Inter-Bold.woff")}) format("woff");
    font-weight: ${FontWeight.bold};
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Inter Grab Web";
    src: url(${require("grab-ui/assets/fonts/Inter-ExtraBold.woff2")})
        format("woff2"),
      url(${require("grab-ui/assets/fonts/Inter-ExtraBold.woff")})
        format("woff");
    font-weight: ${FontWeight.extraBold};
    font-style: normal;
    font-display: swap;
  }
  #food * {
    font-family: "Inter Grab Web";
    box-sizing: border-box;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  button:focus {
    outline: none;
  }
  button {
    padding: 0;
  }
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
  tr,
  td {
    margin: 0;
    padding: 0;
  }
  .ant-calendar-header .ant-calendar-prev-century-btn:after,
  .ant-calendar-header .ant-calendar-prev-decade-btn:after,
  .ant-calendar-header .ant-calendar-prev-year-btn:after {
    content: "«";
  }
  .ant-calendar-header .ant-calendar-prev-month-btn:after {
    content: "‹";
  }
  .ant-calendar-header .ant-calendar-next-month-btn:after {
    content: "›";
  }
  .ant-calendar-header .ant-calendar-next-century-btn:after,
  .ant-calendar-header .ant-calendar-next-decade-btn:after,
  .ant-calendar-header .ant-calendar-next-year-btn:after {
    content: "»";
  }

  button.ant-btn {
    overflow: hidden;
    text-overflow: ellipsis;

    &.ant-btn-primary[disabled] {
      border: 1px solid ${theme.colors.border};
    }
    &.ant-btn-link {
      border: none;
      padding: 0;
      background-color: rgba(0, 0, 0, 0) !important;
      height: auto;
      &:not(:disabled) {
        color: #00a5cf;
      }
    }
    &:not(.ant-btn-link):not(.ant-btn-primary):not(.ant-btn-danger) {
      border: 1px solid ${theme.colors.border};
    }
    // &:not(.ant-dropdown-trigger) > span {
    //   overflow: hidden;
    //   white-space: nowrap;
    //   display: block;
    //   text-overflow: ellipsis;
    // }
  }

  button.ant-drawer-close {
    .anticon-close:before {
      content: none;
    }
  }

  .main-layout {
    flex-direction: row;
    display: flex;
    min-height: 100vh;

    .ant-menu-inline-collapsed > .ant-menu-item,
    .ant-menu-inline-collapsed
      > .ant-menu-item-group
      > .ant-menu-item-group-list
      > .ant-menu-item,
    .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
      padding: 0 16px !important;
    }
    section {
      width: 0px;
    }
  }

  .ant-notification-notice {
    border: 1px solid #33c066;
    .ant-notification-notice-with-icon svg,
    .ant-notification-close-x svg {
      display: none;
    }
  }

  .ant-modal-content {
    .ant-modal-close-x {
      display: none;
    }

    .ant-modal-confirm-body {
      i {
        display: none;
      }
      .ant-modal-confirm-title {
        font-size: 18px;
        font-weight: 500;
      }
      .ant-modal-confirm-content {
        font-size: 16px;
        margin-top: 16px;
      }
    }
  }
  .ant-modal-confirm .ant-modal-confirm-btns {
    margin-top: 42px;
    display: flex;
    button {
      width: 50%;
      & + button {
        margin-bottom: 0;
        margin-left: 8px;
      }
    }
  }

  /* red btn */
  button.ant-btn.red-btn
    :not(.ant-btn-link)
    :not(.ant-btn-primary)
    :not(.ant-btn-danger)
    :not([disabled])
    :hover {
    border: 1px solid #f55538;
  }

  button.red-btn {
    color: #f55538;
    background-color: #ffffff;
  }

  button.red-btn:hover:not([disabled]),
  button.red-btn:focus {
    color: #f55538;
    background: linear-gradient(
        0deg,
        rgba(245, 85, 56, 0.1),
        rgba(245, 85, 56, 0.1)
      ),
      #ffffff;
  }

  /* Blue btn */
  button.blue-btn:hover,
  button.blue-btn:focus {
    color: #1a1a1a;
    background: rgba(0, 165, 207, 0.1);
    border: 1px solid #00a5cf;
    &:not(.ant-btn-link):not(.ant-btn-primary):not(.ant-btn-danger) {
      border: 1px solid #00a5cf;
    }
  }

  button.blue-btn:disabled,
  button.blue-btn[disabled] {
    color: #b3b3b4;
    &:hover {
      color: #b3b3b4;
    }
    &:not(.ant-btn-link):not(.ant-btn-primary):not(.ant-btn-danger) {
      border: 1px solid #e2e2e2;
    }
  }

  /* Blue btn v2*/
  button.blue-btn-v2 {
    color: #00a5cf;
  }
  button.blue-btn-v2:hover,
  button.blue-btn-v2:focus {
    color: #00a5cf;
    background: rgba(0, 165, 207, 0.1);
    border: 1px solid #00a5cf;
    &:not(.ant-btn-link):not(.ant-btn-primary):not(.ant-btn-danger) {
      border: 1px solid #00a5cf;
    }
  }

  button.blue-btn-v2:disabled,
  button.blue-btn-v2[disabled] {
    &:not(.ant-btn-link):not(.ant-btn-primary):not(.ant-btn-danger) {
      border: 1px solid ${theme.colors.border};
    }
  }

  /* Blue btn primary*/
  button.blue-btn-primary:not([disabled]) {
    color: #ffffff;
    background-color: #0595da;
    border-color: #0595da !important;
    &:hover,
    &:focus {
      background: #05a2ed;
      border-color: #05a2ed !important;
    }
    &:active {
      background: #0483bf;
      border-color: #0483bf !important;
    }
  }

  /* Tag */
  .ant-tag {
    font-weight: 500;
    cursor: unset;
    padding: 0 14px;
    border-radius: 100px;
  }
  .ant-tag-orange {
    color: #ffffff;
    background-color: #f76708;
    border: none;
  }

  /* Radio */
  .ant-radio-button-wrapper {
    border-color: ${theme.colors.border};
  }
  .blue-radio {
    .ant-radio-button-wrapper {
      box-shadow: none !important;
      &:hover {
        color: #00a5cf;
        border-color: #00a5cf !important;
      }
    }
  }

  .blue-radio.grab-ui.ant-radio-button-wrapper:checked:not(.ant-radio-button-wrapper-disabled),
  .blue-radio.grab-ui .ant-radio-button-wrapper-checked:hover,
  .blue-radio.grab-ui
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background-color: #00a5cf !important;
    border-color: #00a5cf !important;
    &:hover {
      color: white;
    }
  }

  .primary-radio {
    .ant-radio-checked {
      .ant-radio-inner {
        &:after {
          background-color: #00b14f;
        }
        border-color: #00b14f;
      }
    }
  }

  .large-radio {
    .ant-radio-inner {
      top: 0;
      width: 24px;
      height: 24px;
      border-width: 2px;
      &:after {
        left: 4px;
        top: 4px;
        width: 12px;
        height: 12px;
      }
    }
  }

  .primary-checkbox {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #00b14f;
      border-color: #00b14f;
    }
  }

  .large-checkbox {
    .ant-checkbox-inner {
      width: 24px !important;
      height: 24px !important;
      &:after {
        top: 4px;
        left: 8px;
        transform: rotate(45deg) scale(1.5);
      }
    }
  }

  /* Dropdown */
  .ant-dropdown-button {
    display: flex;
  }

  /* Divider */
  .ant-divider {
    background: ${theme.colors.border};
  }

  /* Tooltip */
  .tooltip-blue {
    .ant-tooltip-inner {
      background-color: #0595da;
    }
    .ant-tooltip-arrow {
      border-top-color: #0595da;
      border-bottom-color: #0595da;
    }
  }

  /* Table */
  .ant-table {
    border: 1px solid ${theme.colors.border};
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    background: #fff;
    &.ant-table-column-sort {
      background: #fff;
    }
  }
  .ant-table-thead
    > tr
    > th
    .anticon-filter:after
    .ant-table-filter-icon:after {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    left: -5px;
    top: -5px;
    background-color: rgba(0, 165, 207, 0.1);
  }
  .ant-table-filter-icon:before {
    font-family: "anticon" !important;
    content: "\\e663";
    font-style: normal;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    word-break: unset !important;
  }

  /* .ant-table-column-sorter {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: rgba(0, 165, 207, 0.1);
  } */
  .ant-table-column-sorter-up.on .anticon-caret-up,
  .ant-table-column-sorter-down.on .anticon-caret-up,
  .ant-table-column-sorter-up.on .anticon-caret-down,
  .ant-table-column-sorter-down.on .anticon-caret-down {
    color: #00a5cf;
  }
  .ant-table-body table th > span .grab-ui.ant-dropdown-trigger {
    color: #00a5cf;
  }
  .ant-table-thead > tr > th {
    border-bottom: 1px solid ${theme.colors.border};
  }
  .ant-table-filter-dropdown {
    min-width: 280px;
    max-width: 380px;
  }
  .ant-table-wrapper .ant-dropdown-menu-item {
    line-height: 52px;
    /* padding: 0; */
    border-bottom: 1px solid #f1f0f0;
  }
  .ant-table-wrapper
    .ant-table-filter-dropdown
    .ant-dropdown-menu-item
    > label
    + span {
    font-size: 16px;
  }
  .ant-table-filter-dropdown-link.clear {
    display: none;
  }
  .ant-table-filter-dropdown-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 0px;
  }
  .ant-table-filter-dropdown-link {
    color: #00a5cf;
    font-weight: 500;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00a5cf;
    border-color: #00a5cf;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #00a5cf;
    border-color: #00a5cf;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner:after {
    transform: none;
  }
  .ant-radio-checked {
    .ant-radio-inner {
      &:after {
        background-color: #00a5cf;
      }
      border-color: #00a5cf;
    }
  }
  .ant-dropdown-menu-item-selected {
    color: #363a45;
  }
  .ant-table-wrapper .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-table-wrapper .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #00a5cf;
  }
  .ant-table-wrapper .ant-checkbox-wrapper {
    padding: 5px 12px;
  }
  .ant-table-tbody > tr:hover > td {
    background: #f3f6fb;
    cursor: pointer;
  }
  .ant-table-tbody tr td {
    font-size: 16px;
  }
  .ant-table-tbody tr {
    &:last-child {
      td {
        border-bottom: unset;
      }
    }
  }
  .ant-table-placeholder {
    border-bottom: unset;
  }
  .ant-dropdown,
  .ant-select-dropdown {
    box-shadow: 0px 1px 13px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    ul {
      // border-radius: 6px 6px 0 0;
      li {
        &.ant-select-dropdown-menu-item-active,
        &.ant-select-dropdown-menu-item-selected {
          color: unset !important;
        }
        //   border-radius: 0;
        &:not(:last-child) {
          border-bottom: 1px solid ${theme.colors.border};
        }
        &:hover
          :not(.ant-select-dropdown-menu-item-group)
          :not([disabled])
          :not(.ant-dropdown-menu-item-disabled)
          :not(.custom-filter-dropdown-group-item)
          :not(.troy-setting-dropdown-items) {
          background-color: #f3f6fb !important;
          color: unset !important;
          // border-radius: 0;
        }
      }
    }
  }
  .custom-filter-dropdown-group-item {
    pointer-events: none;
    background-color: #ffffff;
    * {
      cursor: default;
      pointer-events: all;
    }
    font-size: 12px;
    font-weight: bold;
    padding: 16px;
    line-height: unset !important;
    .ant-checkbox-wrapper {
      display: none;
    }
  }
  .ant-drawer-header {
    position: sticky;
    top: 0;
    z-index: 10000;
  }
  .ant-drawer-body {
    padding: 0;
    height: calc(100% - 55px);
  }
  .ant-form-item-required:before {
    display: none;
  }
  .ant-form-item-required:after {
    display: inline-block;
    margin-left: 4px !important;
    margin-right: 0 !important;
    content: "*" !important;
    font-family: SimSun;
    line-height: 1;
    font-size: 14px;
  }
  .ant-form-item {
    margin-bottom: 8px;
  }
  .grab-ui.ant-form-item-label label {
    color: #2d2d2d;
  }
  .ant-input {
    border-color: ${theme.colors.border};
  }
  .ant-input,
  .ant-select-selection {
    &:not(:disabled, [disabled]) {
      &:hover,
      &:focus {
        border-color: #00a5cf !important;
        box-shadow: 0 0 0 2px rgb(0 165 207 / 20%);
      }
    }
    &:disabled,
    &[disabled] {
      border-color: unset !important;
      padding: 12px;
    }
    .anticon-down:before {
      display: none;
    }
  }
  .ant-select-disabled {
    .ant-select-selection {
      &:hover,
      &:focus {
        border-color: unset !important;
      }
      .ant-select-arrow {
        opacity: 0.5;
      }
    }
  }
  .ant-select-selection {
    overflow: hidden;
    height: 100% !important;
  }
  .ant-select-selection__rendered {
    margin-right: 20px;
    height: 100%;
  }
  .ant-select-arrow {
    color: #3d3d3d;
  }
  .ant-select-sm {
    // style adjustment for select with small size
    height: 36px;
    * {
      font-size: 14px;
    }
    .ant-select-selection-selected-value {
      height: 100%;
      padding: 9px 0 9px 9px !important;
    }
    .ant-select-selection__rendered {
      margin-right: 25px;
    }
  }
  .form-select {
    // custom style for form select components
    .ant-select-selection-selected-value {
      height: 100%;
      padding: 11px 20px 13px 12px !important;
    }
    .ant-select-arrow {
      background: #f5f5f5;
      font-size: 16px;
      height: calc(100% + 1px);
      width: 40px;
      right: 0;
      padding-top: 12px;
      bottom: 2px;
    }
  }
  .menu-timepicker {
    // custom style for time picker component
    &.ant-time-picker-panel {
      pointer-events: none;

      * {
        pointer-events: auto;
      }
    }
    .ant-time-picker-panel-inner {
      top: 45px;
      left: -25px;
    }
    .ant-time-picker-panel-input-wrap {
      display: none;
    }
    .ant-time-picker-panel-select {
      ul {
        li {
          color: unset !important;
          text-align: center;
          padding: 0;
        }
      }

      .ant-time-picker-panel-select-option-selected {
        color: #00a5cf !important;
      }
    }
  }
  .selling-time-dropdown-overlay {
    // custom style for selling time dropdown overlay
    overflow: hidden;
    .grab-ui.ant-menu-vertical {
      width: unset !important;
      max-height: 240px;
      overflow: auto;
      border-radius: unset !important;
    }
    .ant-menu-vertical > .ant-menu-item {
      height: unset;
      line-height: 1.5;
      margin: 0;
    }
    .grab-ui:not(.ant-menu-horizontal).grab-ui.ant-menu-item-selected {
      font-weight: unset;
      color: unset !important;
    }
  }
  .troy-sidebar-v1 {
    width: 232px;

    .button-download-app {
      margin-left: unset;
    }
    .button-download-app-border {
      border-radius: 8px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ant-menu-inline-collapsed {
      width: unset;
    }
    .ant-menu-vertical {
      background: unset !important;
    }
  }
  .ant-layout {
    background: white;
  }
  .sidebar-collapsed {
    width: ${TROY_SIDEBAR_COLLAPSED_WIDTH}px;
    min-width: ${TROY_SIDEBAR_COLLAPSED_WIDTH}px;
  }
  .sidebar-expanded {
    width: ${TROY_SIDEBAR_WIDTH}px;
    min-width: ${TROY_SIDEBAR_WIDTH}px;
  }
  .site-layout {
    position: relative;
    display: flex;
    flex-direction: column;
    // this width fixes weird bug where an horizontal overflow element (long element) breaks layout
    // the real width is going to be auto derived by flex: 1 below it
    width: 1px;
    flex: 1;
    overflow-x: auto;

    .site-layout-content {
      max-width: ${CONTENT_MAX_WIDTH}px;
      min-width: calc(
        ${CONTENT_MIN_WIDTH}px - ${TROY_SIDEBAR_COLLAPSED_WIDTH}px
      );
      width: 100%;
      margin: 0 auto;
      position: relative;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
  .site-layout-content-collapsed .order-bottom-drawer {
    left: ${TROY_SIDEBAR_COLLAPSED_WIDTH}px;
  }
  .site-layout-content-expanded .order-bottom-drawer {
    left: ${TROY_SIDEBAR_WIDTH}px;
  }
  .order-bottom-drawer {
    border: 1px;
    box-sizing: border-box;
    padding: 16px 16px;
    height: 66px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    position: fixed;
    bottom: 0;
    /* greys and black/white */
    background: #ffffff;
    /* Reversed */
    box-shadow: 0px -2px 12px rgba(28, 28, 28, 0.1);
    right: 0;
    margin: 0 auto;
    overflow-x: auto;
    overflow-y: hidden;
    max-width: ${CONTENT_MAX_WIDTH}px;

    & > .ant-row {
      min-width: 900px;
    }

    & > .dui-row {
      min-width: 920px;
    }

    &::-webkit-scrollbar {
      height: 7px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background-color: rgba(0, 0, 0, 0.25);
    }
  }
  .ant-menu-inline-collapsed-tooltip,
  .ant-dropdown-menu-inline-collapsed-tooltip {
    display: none;
  }
  .unread-table-style {
    background-color: #d9fcde;
  }

  .ant-badge > .ant-scroll-number > .ant-scroll-number-only > p {
    display: block;
  }

  .ant-drawer-content-wrapper {
    max-width: 100%;
  }

  @media (max-width: 480px) {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > th,
    .ant-table-thead > tr > td,
    .ant-table-tbody > tr > td {
      display: table-cell;
    }
  }
`
